
import React from 'react';
import { media } from '../../server';
import { useStateContext } from '../../context/ContextProvider';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { renderText, truncateText } from '../hooks/TextVeiw';
import { truncateTitle } from '../../middleware/truncateTitle';
import { motion } from 'framer-motion';

import {
  FiArrowLeft,
  FiArrowRight,
  FiGrid
} from 'react-icons/fi';

import {
  FaUtensils
} from 'react-icons/fa';

function MealCategoryCard({ category, index = 0 }) {

  const { currentDir } = useStateContext();
  const { t } = useTranslation();

  return (

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      viewport={{ once: true }}
      whileHover={{ y: -10 }}
      className="group relative"
    >

      <div className="relative overflow-hidden rounded-[2rem] bg-white dark:bg-back-darksecondary border border-color-1/10 shadow-xl hover:shadow-2xl duration-500">

        {/* Glow */}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 duration-500">

          <div className="absolute top-0 right-0 w-40 h-40 bg-color-1/10 rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 left-0 w-40 h-40 bg-color-3/10 rounded-full blur-3xl"></div>

        </div>

        {/* Top */}
        <div className="relative p-5 pb-0">

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-color-1/10 border border-color-1/10 mb-5">

            <FiGrid className="text-color-1" />

            <span className="text-color-1 text-sm font-kufi">
              {t("Category")}
            </span>

          </div>

        </div>

        {/* Image */}
        <div className="relative px-5">

          <div className="relative overflow-hidden rounded-[1.7rem] h-64">

            <img
              src={`${media}${category?.Image}`}
              alt={
                currentDir === "ltr"
                  ? category.titleEn
                  : category.titleAr
              }
              className="w-full h-full object-cover group-hover:scale-110 duration-700"
            />

            {/* Soft Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>

          </div>

          {/* Floating Icon */}
          <div className="absolute -bottom-5 left-10 w-14 h-14 rounded-2xl bg-color-1 shadow-2xl flex items-center justify-center border-4 border-white dark:border-back-darksecondary">

            <FaUtensils className="text-white text-xl" />

          </div>

        </div>

        {/* Content */}
        <div className="relative pt-10 p-6">

          {/* Title */}
          <h2 className="text-2xl font-kufi text-tcolor-4 dark:text-tcolor-1 mb-4 line-clamp-1 group-hover:text-color-1 duration-300">

            {
              currentDir === "ltr"
                ? truncateTitle(category.titleEn, 4)
                : truncateTitle(category.titleAr, 4)
            }

          </h2>

          {/* Description */}
          <p className="body-3 text-gray-600 dark:text-gray-300 leading-loose line-clamp-3 min-h-[80px]">

            {
              renderText(
                truncateText(
                  currentDir === "ltr"
                    ? category.textEn
                    : category.textAr,
                  24
                )
              )
            }

          </p>

          {/* Divider */}
          <div className="my-6 w-full h-[1px] bg-gradient-to-r from-transparent via-color-1/20 to-transparent"></div>

          {/* CTA */}
          <Link
            to={`/AllMeals`}
            state={{ category }}
            onClick={() => window.scrollTo(0, 0)}
          >

            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.97 }}
              className="group/button w-full bg-color-1/10 hover:bg-color-1 duration-300 rounded-2xl py-4 px-5 flex items-center justify-between cursor-pointer"
            >

              <span className="font-kufi text-color-1 group-hover/button:text-white duration-300">

                {t("View Meals")}

              </span>

              <div className="w-10 h-10 rounded-xl bg-white/80 group-hover/button:bg-white flex items-center justify-center duration-300">

                <FiArrowLeft className="text-color-1" />

              </div>

            </motion.div>

          </Link>

        </div>

      </div>

    </motion.div>
  );
}

export default MealCategoryCard;

